export default function getResource(label, vars = []) {
    const resources = {
        autoReplenishTitle: `Réapprovisionnement automatique (${vars[0]})`,
        changeMethod: 'Changer la méthode',
        qtyUpdateError: 'We couldn’t update qty. Please try again.',
        retry: 'Retry'
    };

    return resources[label];
}
